export default __webpack_public_path__ + "static/media/logo.c640e196.png";